var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMinus = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 3,
    viewBox: "0 0 11 3",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 0.375C9.95312 0.375 10.125 0.453125 10.2656 0.609375C10.4219 0.75 10.5 0.921875 10.5 1.125V1.875C10.5 2.07812 10.4219 2.25781 10.2656 2.41406C10.125 2.55469 9.95312 2.625 9.75 2.625H0.75C0.546875 2.625 0.367188 2.55469 0.210938 2.41406C0.0703125 2.25781 0 2.07812 0 1.875V1.125C0 0.921875 0.0703125 0.75 0.210938 0.609375C0.367188 0.453125 0.546875 0.375 0.75 0.375H9.75Z",
    fill: "#8C8C8C"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMinus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/minus.78bc91dc.svg";
export { ForwardRef as ReactComponent };